import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Host, AppService } from "../../../../../common";
import { Cart, CartEntry, CartService, Order } from "../../../../../common";

@Component({
  selector: 'paypal-cancel',
  standalone: false,
  templateUrl: './paypal-cancel.html'
})

export class PaypalCancelPage implements OnInit {

  cart: Cart;
  host: Host;
  orderid: number;
  order: Order;
  orderCancelled: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private cartService: CartService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.orderid = parseInt(params.get('orderid'));
      this.order = this.cartService.getOrder(this.orderid);
      this.orderCancelled = (this.order.status == 'C');
    });
    this.appService.load().subscribe(({host, cart}) => {
      this.host = host;
      this.cart = cart;
    })
  }

  onBtCancel(event: MouseEvent) {
    event.preventDefault();
    this.cartService.updateOrder(this.orderid, 'C', '').toPromise().then((result) => {
    this.orderCancelled = true;
    });

  }

  onBtCash(event: MouseEvent) {
    event.preventDefault();
    this.cartService.updateOrder(this.orderid, '', 'cash').toPromise().then((result) => {
      this.router.navigate(['/', 'cash', this.orderid, 'success'])
    });
  }

  canClose() {
    return this.appService.canClose();
  }

  onBtClose(event: MouseEvent) {
    event.preventDefault();
    this.appService.closeApp();
  }

}
